import axios from 'axios'
import userProfile from "../firebase/user";
import { AnyAction, Store } from "redux";
import { auth } from "../firebase";
import { History } from "history";
import { auth as fbAuth } from "../firebase/firebase";
import cfApi from "./cfApi";

// let baseURL = "http://172.105.239.35:8080/";
// let baseURL = "https://lei-cao.com/";
let baseURL = "https://europe-west1-remerge-se.cloudfunctions.net/RemergeAPI/";
if (process.env.NODE_ENV !== 'production') {
    // baseURL = "http://localhost:8080/";
}

let proxyURL = baseURL + 'proxy';

const api = axios.create({
    baseURL: baseURL,
    timeout: 20000,
    headers: {
        'Access-Control-Allow-Origin': '*',
    }
});

api.interceptors.request.use((config) => {
    config.headers.common['Authorization'] = userProfile.idToken;
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
});

const setupInterceptors = (store: Store<any, AnyAction>, history: History<any>) => {

    api.interceptors.response.use(response => {
        return response;
    }, error => {
        const config = error.config

        if (error.response.status !== 401) {
            return Promise.reject(error)
        }
        // Set the variable for keeping track of the retry count
        config.__retryCount = config.__retryCount || 0

        // Check if we've maxed out the total number of retries
        if (config.__retryCount > 0) {
            if (error.response.status === 401) {
                auth.doSignOut()
                return
            }
            // Reject with the error
            return Promise.reject(error)
        }

        // Increase the retry count
        config.__retryCount += 1

        // Create new promise to handle exponential backoff
        const backoff = new Promise<void>(function (resolve) {
            setTimeout(function () {
                resolve()
            }, config.retryDelay || 1)
        })

        // Return the promise in which recalls axios to retry the request
        return backoff.then(function () {
            let currentUser = fbAuth.currentUser;
            if (currentUser != null) {
                currentUser.getIdToken().then(function (result) {
                    userProfile.currentUser = currentUser;
                    userProfile.idToken = result;

                    api.interceptors.request.use((config) => {
                        config.headers.common['Authorization'] = userProfile.idToken;
                        return config
                    }, function (error) {
                        // Do something with request error
                        return Promise.reject(error)
                    });
                    return axios.request(config);

                }).catch(function (error) {
                    console.log(error);
                })
            }
        })

    });
}

export default api;

export { baseURL, proxyURL, setupInterceptors }
